
import {put, select} from 'redux-saga/effects'
import * as actions from '../actionTypes'

export function* checkFactorEditing(action) {
    const editFactorIndex = yield select(state => state.counselingSession.editingFactorIndex)

    const isEditingFactor = (editFactorIndex !== null)

    if(isEditingFactor) {
      yield put({type: actions.REQUEST_FACTOR_ACTION, payload: action})
    }

    return isEditingFactor
}


// WEBPACK FOOTER //
// ./src/sagas/helpers.js